import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DailyEntry from "@/pages/DailyEntry";
import FixedCosts from "@/pages/FixedCosts";
import Reports from "@/pages/Reports";
import MenuSettings from "@/pages/MenuSettings";
import StaffSalary from "@/pages/StaffSalary";
import Compare from "@/pages/Compare";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen grid place-items-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/entry" element={<Protected><DailyEntry /></Protected>} />
          <Route path="/fixed-costs" element={<Protected><FixedCosts /></Protected>} />
          <Route path="/staff" element={<Protected><StaffSalary /></Protected>} />
          <Route path="/compare" element={<Protected><Compare /></Protected>} />
          <Route path="/reports" element={<Protected><Reports /></Protected>} />
          <Route path="/menu" element={<Protected><MenuSettings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
